import React, { FC, memo } from 'react'
import { VideoPreview } from '@ucheba/ui/components/VideoPreview/desktop'
import { Box } from '@ucheba/ui/components/Box/desktop'
import { Heading } from '@ucheba/ui/components/Heading/desktop'
import { Text } from '@ucheba/ui/components/Text/desktop'
import { Button } from '@ucheba/ui/components/Button/desktop'
import { Spacing } from '@ucheba/ui/components/Spacing/desktop'
import { List, ListItem } from '@ucheba/ui/components/List/desktop'
import styled from 'styled-components'
import { sv } from '@ucheba/utils/helpers/styles/variables'
import SC from '../base/styles'
import { ITeacherCardItem } from '../types'
import { useTeachersListWithIcons } from '../bll'

const {
  VideoPreviewExperienceText,
  VideoPreviewAverageScoreText,
  StyledBox,
  BlockWithGradient,
} = SC

const LeftBlock = styled.div`
  border-radius: ${sv.spacing.xxsmall} 0 0 ${sv.spacing.xxsmall};
  overflow: hidden;
  height: 100%;
`

const RightBlock = styled.div`
  border-radius: 0 ${sv.spacing.xxsmall} ${sv.spacing.xxsmall} 0;
  overflow: hidden;
  background-color: white;
  height: 100%;
  padding: ${sv.spacing.large};
`

const VideoPreviewOverlayTeacher = styled.div`
  display: flex;
  justify-content: space-between;
  flex: 1;
`

const WrapperPreview = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`

const ButtonSC = styled(Button)`
  width: 100%;
`

const TeacherCardExtra: FC<ITeacherCardItem> = (props) => {
  const {
    name,
    description,
    buttonText,
    onClick,
    href,
    previewImage,
    experience,
    avgScore,
    width = '100%',
    list,
    previewImageSqure,
  } = props

  const listWithIcons = useTeachersListWithIcons(list)

  return (
    <div
      style={{
        width,
        display: 'flex',
      }}
    >
      <div
        style={{
          width: '50%',
        }}
      >
        <LeftBlock>
          {href ? (
            <VideoPreview
              height='100%'
              size='small'
              imgUrl={previewImageSqure || previewImage}
              withIcon={false}
              notHover
              Overlay={
                // eslint-disable-next-line react/jsx-wrap-multilines
                <WrapperPreview as={Box} spacing='large'>
                  <VideoPreviewOverlayTeacher>
                    <VideoPreviewExperienceText>
                      {experience.text && experience.scoreText && (
                        <>
                          <Heading
                            as='div'
                            h3={experience.scoreText}
                            color='gold'
                            spacing='uxsmall'
                          />

                          <Text fontSize='small2' lineHeight='small2' color='gold'>
                            {experience.text}
                          </Text>
                        </>
                      )}
                    </VideoPreviewExperienceText>

                    <VideoPreviewAverageScoreText>
                      {avgScore.scoreText && avgScore.text && (
                        <>
                          <Heading
                            as='div'
                            textAlign='right'
                            h3={avgScore.scoreText}
                            color='gold'
                            spacing='uxsmall'
                          />

                          <Text
                            textAlign='right'
                            fontSize='small2'
                            lineHeight='small2'
                            color='gold'
                          >
                            {avgScore.text}
                          </Text>
                        </>
                      )}
                    </VideoPreviewAverageScoreText>
                  </VideoPreviewOverlayTeacher>

                  <div style={{ flex: 1 }} />

                  <Button color='gold' view='outline'>
                    Смотреть видео
                  </Button>

                  <BlockWithGradient />
                </WrapperPreview>
              }
            />
          ) : (
            <VideoPreview
              height='100%'
              size='small'
              imgUrl={previewImageSqure || previewImage}
              withIcon={false}
              notHover
              Overlay={
                // eslint-disable-next-line react/jsx-wrap-multilines
                <WrapperPreview as={Box} spacing='large'>
                  <VideoPreviewOverlayTeacher>
                    <VideoPreviewExperienceText>
                      {experience.text && experience.scoreText && (
                        <>
                          <Heading
                            as='div'
                            h3={experience.scoreText}
                            color='gold'
                            spacing='uxsmall'
                          />

                          <Text fontSize='small2' lineHeight='small2' color='gold'>
                            {experience.text}
                          </Text>
                        </>
                      )}
                    </VideoPreviewExperienceText>

                    <VideoPreviewAverageScoreText>
                      {avgScore.scoreText && avgScore.text && (
                        <>
                          <Heading
                            as='div'
                            textAlign='right'
                            h3={avgScore.scoreText}
                            color='gold'
                            spacing='uxsmall'
                          />

                          <Text
                            textAlign='right'
                            fontSize='small2'
                            lineHeight='small2'
                            color='gold'
                          >
                            {avgScore.text}
                          </Text>
                        </>
                      )}
                    </VideoPreviewAverageScoreText>
                  </VideoPreviewOverlayTeacher>
                  <BlockWithGradient />
                </WrapperPreview>
              }
            />
          )}
        </LeftBlock>
      </div>

      <div
        style={{
          width: '50%',
        }}
      >
        <RightBlock>
          <StyledBox>
            <Heading h2={name} />

            <Spacing spacing='xsmall' />

            <Text>{description}</Text>

            <Spacing spacing='xsmall' />

            {listWithIcons && (
              <List spacing='small'>
                {listWithIcons.map(({ color, Icon, text }, index) => (
                  <ListItem
                    startIconSpacing='xsmall'
                    key={index}
                    StartIcon={<Icon color={color} width='20px' height='20px' />}
                  >
                    <Text color='black'>{text}</Text>
                  </ListItem>
                ))}
              </List>
            )}

            <Spacing spacing='medium' />

            {href ? (
              <ButtonSC color='orange' href={href}>
                {buttonText}
              </ButtonSC>
            ) : (
              <ButtonSC color='orange' onClick={onClick}>
                {buttonText}
              </ButtonSC>
            )}
          </StyledBox>
        </RightBlock>
      </div>
    </div>
  )
}

export default memo(TeacherCardExtra)
